import { render } from "./bill-sum.vue?vue&type=template&id=fa15718e&scoped=true&ts=true"
import script from "./bill-sum.vue?vue&type=script&lang=ts"
export * from "./bill-sum.vue?vue&type=script&lang=ts"

import "./bill-sum.vue?vue&type=style&index=0&id=fa15718e&scoped=true&lang=stylus"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa15718e"]])

export default __exports__